import { pathOr as remedaPathOr } from 'remeda';

/**
 * Remeda `pathOr` allows any path without restrictions, fallback to default value.
 * We have different type of cards, answers, etc, so we need to use this function
 * to quickly get the value from the state without unnecessary type guards.
 *
 * Ex: get an answer `isFreeForm` which only be available in LinearAnswer, if the answer
 * is not a LinearAnswer, it will return undefined.
 * ```ts
 * const isFreeForm = pathOr<LinearAnswerState['isFreeForm']>(
 *     get(),
 *     ['answers', answerId, 'isFreeForm'],
 *     undefined
 * );
 * ```
 */
export const pathOr = <T>(
    obj: Record<string, unknown>,
    path: string[],
    defaultValue: T
): T =>
    // @ts-expect-error allow any path
    remedaPathOr(obj, path, defaultValue);
